export const SUPPORT_ADD_TICKET_COMMENT = 'SUPPORT_ADD_TICKET_COMMENT'
export const SUPPORT_DESTROY_CURRENT_TICKET = 'SUPPORT_DESTROY_CURRENT_TICKET'
export const SUPPORT_DESTROY_TICKET_LIST = 'SUPPORT_DESTROY_TICKET_LIST'
export const SUPPORT_FETCH_TICKET_DETAILS = 'SUPPORT_FETCH_TICKET_DETAILS'
export const SUPPORT_FETCH_TICKETS = 'SUPPORT_FETCH_TICKETS'
export const SUPPORT_FETCH_TICKETS_SHIPMENTS = 'SUPPORT_FETCH_TICKETS_SHIPMENTS'
export const SUPPORT_GO_TO_DRAFT_TICKET = 'SUPPORT_GO_TO_DRAFT_TICKET'
